export const useOnBeforeTaskDrag = (
  gantt,
  isTaskDateRollupEnabled,
  isRolledUpTaskEstimateCalculationMethodEnabled
) => (id, mode) => {
  const task = gantt.getTask(id);
  const isTask = isRolledUpTaskEstimateCalculationMethodEnabled
    ? gantt.getTaskByIndex(0).id !== id
    : true;
  const canResize = Boolean(isTask && task.startDate && task.endDate);

  if (!isTaskDateRollupEnabled) {
    return canResize;
  }
  const { hasChildren } = task;

  if (hasChildren) {
    return false;
  }

  return canResize;
};

export default useOnBeforeTaskDrag;
